export const GOOGLE_ORIGIN_URL = 'google.com';

export const OUTLOOK_ORIGIN_URL = 'addin.grooveapp.com';

export const SALESFORCE_BASE_URL = 'force.com';

export const ZOOMINFO_ORIGIN_URL = 'app.zoominfo.com';
